import type { CreateLayerInput, Layer, UpdateLayerInput } from "shared";
import { api } from "./client";

export const layersApi = {
	list: (mapId: string) => api.get<{ layers: Layer[] }>(`/maps/${mapId}/layers`),
	create: (mapId: string, input: CreateLayerInput) =>
		api.post<{ layer: Layer }>(`/maps/${mapId}/layers`, input),
	update: (id: string, input: UpdateLayerInput) =>
		api.patch<{ layer: Layer }>(`/layers/${id}`, input),
	remove: (id: string) => api.del<{ ok: boolean }>(`/layers/${id}`),
};
